<template>
    <settings-editor-base>
        <template>
            <button class="btn btn-primary" @click="showModal">
                {{label}}
            </button>

            <modal v-bind:size="modalSize" ref="cropperModal">
                <template v-slot:modal-header>
                    <h3>{{resource('SettingsMediaCropper_ModalHeader_Text')}}</h3>
                </template>

                <template v-slot:modal-body>
                    <media-library-image-crop
                            v-bind:image-id="mediaId"
                            @image-cropped="imageCropped($event.mediaId, $event.crop)"
                    >
                    </media-library-image-crop>
                </template>
            </modal>
        </template>
    </settings-editor-base>
</template>

<script>
    import resourceMixin from "../../../../Util/Mixins/resources";
    
    import MediaLibraryImageCrop from "../../../MediaLibrary/Components/MediaLibraryImageCrop.vue";
    import Modal, {sizes} from "../../../../Components/Util/Modal.vue";
    import SettingsEditorBase from "./SettingsEditorBase.vue";
    
    export default {
        name: "settings-media-cropper",
        mixins: [resourceMixin],
        components: {
            SettingsEditorBase,
            MediaLibraryImageCrop,
            Modal
        },
        methods: {
            imageCropped(mediaId, crop){
                const vm = this;
                
                vm.$emit('image-cropped', { mediaId: mediaId, crop: crop });
                vm.hideModal();
            },
            showModal(){
                const vm = this;
                
                vm.$refs.cropperModal.show();
            },
            hideModal(){
                const vm = this;
                
                vm.$refs.cropperModal.hide();
            }
        },
        data: () => ({
            modalSize: sizes.extraLarge
        }),
        props: {
            label: {
                type: String,
                required: true
            },
            mediaId: {
                type: String,
                required: true
            }
        }
    };
</script>
